"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetEstimatedValuesResponsesEstimatedValuesWrapper$ = exports.FastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetEstimatedValuesResponsesEstimatedValuesWrapper$outboundSchema = exports.FastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetEstimatedValuesResponsesEstimatedValuesWrapper$inboundSchema = void 0;
exports.fastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetEstimatedValuesResponsesEstimatedValuesWrapperToJSON = fastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetEstimatedValuesResponsesEstimatedValuesWrapperToJSON;
exports.fastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetEstimatedValuesResponsesEstimatedValuesWrapperFromJSON = fastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetEstimatedValuesResponsesEstimatedValuesWrapperFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const estimatedvalues_js_1 = require("./estimatedvalues.js");
const estimatedvaluesbypropertytype_js_1 = require("./estimatedvaluesbypropertytype.js");
/** @internal */
exports.FastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetEstimatedValuesResponsesEstimatedValuesWrapper$inboundSchema = z.object({
    locality: estimatedvalues_js_1.EstimatedValues$inboundSchema,
    property_type: z.array(estimatedvaluesbypropertytype_js_1.EstimatedValuesByPropertyType$inboundSchema),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "property_type": "propertyType",
    });
});
/** @internal */
exports.FastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetEstimatedValuesResponsesEstimatedValuesWrapper$outboundSchema = z.object({
    locality: estimatedvalues_js_1.EstimatedValues$outboundSchema,
    propertyType: z.array(estimatedvaluesbypropertytype_js_1.EstimatedValuesByPropertyType$outboundSchema),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        propertyType: "property_type",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var FastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetEstimatedValuesResponsesEstimatedValuesWrapper$;
(function (FastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetEstimatedValuesResponsesEstimatedValuesWrapper$) {
    /** @deprecated use `FastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetEstimatedValuesResponsesEstimatedValuesWrapper$inboundSchema` instead. */
    FastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetEstimatedValuesResponsesEstimatedValuesWrapper$.inboundSchema = exports.FastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetEstimatedValuesResponsesEstimatedValuesWrapper$inboundSchema;
    /** @deprecated use `FastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetEstimatedValuesResponsesEstimatedValuesWrapper$outboundSchema` instead. */
    FastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetEstimatedValuesResponsesEstimatedValuesWrapper$.outboundSchema = exports.FastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetEstimatedValuesResponsesEstimatedValuesWrapper$outboundSchema;
})(FastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetEstimatedValuesResponsesEstimatedValuesWrapper$ || (exports.FastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetEstimatedValuesResponsesEstimatedValuesWrapper$ = FastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetEstimatedValuesResponsesEstimatedValuesWrapper$ = {}));
function fastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetEstimatedValuesResponsesEstimatedValuesWrapperToJSON(fastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetEstimatedValuesResponsesEstimatedValuesWrapper) {
    return JSON.stringify(exports.FastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetEstimatedValuesResponsesEstimatedValuesWrapper$outboundSchema
        .parse(fastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetEstimatedValuesResponsesEstimatedValuesWrapper));
}
function fastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetEstimatedValuesResponsesEstimatedValuesWrapperFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.FastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetEstimatedValuesResponsesEstimatedValuesWrapper$inboundSchema
        .parse(JSON.parse(x)), `Failed to parse 'FastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetEstimatedValuesResponsesEstimatedValuesWrapper' from JSON`);
}
//# sourceMappingURL=fastapikrakenendpointsstatsmodelssaleslocalauthoritygetestimatedvaluesresponsesestimatedvalueswrapper.js.map